import { DaghfalApp, registerPushWorker } from '@daghfal/core';
import '@daghfal/core/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { strings } from './strings';

const container = document.getElementById('root');
if (!container) throw new Error('The #root element is missing from index.html.');

// Shows what the API pushes while the app is closed (Q68).
registerPushWorker();

createRoot(container).render(
  <StrictMode>
    <DaghfalApp appKey="guardian" appearance="parent" catalogue={strings}>
      <App />
    </DaghfalApp>
  </StrictMode>,
);
